import SignUpForm from '@/components/auth/SignUpForm'
import { useNavigate } from 'react-router-dom'
import { continueAfterEmailPasswordSignup } from '@/onboarding/post-signup-phone-routing'
import { kDefaultLogoPath } from '@/constants/constants-ui'

export default function SignUpPage() {
  const navigate = useNavigate()

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="mx-auto w-[200px] sm:w-[260px]" src={kDefaultLogoPath} alt="Paxton" />
        </div>

        <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-surface-content px-6 py-12 shadow sm:rounded-lg sm:px-12">
            <SignUpForm
              switchToSignIn={() => navigate('/sign-in')}
              onSuccess={() => {
                navigate('/dashboard')
              }}
              onEmailPasswordAccountCreated={() => continueAfterEmailPasswordSignup(navigate)}
              allowReferral={true}
            />
          </div>
        </div>
      </div>
    </>
  )
}
